<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 5/1/2021
  -->

<template>
	<div v-if="valueData" class="client-access-settings-root">
		<PanelTitle v-if="showHeader">
			Extra Settings
		</PanelTitle>
		<el-checkbox v-model="valueData.canEdit"
					 @change="mainSettingChanged">Proactive client
		</el-checkbox>
		<ToolTipView :analyticsProps="{label: 'Proactive client setting', ...this.analyticsPropsMethod()}" >
			Allows your client to proactively edit this coaching process.
			<br/><br/>
			Enable if you want them to be able to define goals and to add homework on their own (action items).
			<br/><br/>
			Your client can always add their notes despite of this setting.
		</ToolTipView>



	</div>


</template>

<script>
    import BaseVModelView from "@/core/components/BaseVModelView.vue";
	import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";
	import PanelTitle from "@/core/modules/coach/Coaching/Panels/PanelTitle.vue";
	export default {
        name: "ClientAccessSettingsPanel",
		components: {PanelTitle, ToolTipView},
		extends: BaseVModelView,

		props:{
			showHeader: {Boolean, default: true},
			tooltipAnalyticsProps: Object,
			analyticsProps: {Object, default: () => ({})}
		},

		data: () => ({
			activeNames: []
		}),

		methods:{
        	mainSettingChanged(){
        		this.$analyticManager.trackEvent("Proactive client setting changed", {value: this.valueData.canEdit, ...this.analyticsPropsMethod()})
				if(this.valueData.canEdit){
					this.valueData.setAllWrite()
					this.activeNames.push("1")
				} else {
					this.activeNames = []
					this.valueData.setAllRead()
				}
				this.notifyValueChanged()
			},

			analyticsPropsMethod(){
        		return {
        			category: "Client Access Settings",
        			...this.analyticsProps
				}
			}
		}
    }
</script>

<style lang="scss">
.client-access-settings-root{
	.el-collapse{
		border: none;
	}
}

</style>
